import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {OphIconComponent} from './oph-icon.component';

@NgModule({
  imports: [CommonModule],
  declarations: [OphIconComponent],
  exports: [OphIconComponent],
})
export class OphIconModule {}
